
import React, { useState } from "react";
import { FormElement, FormLabel, FormInput, FormSelector, FormToggle } from "../StyledElements";
import { Dialog } from "../Dialog";

const MediaTypeFields = ({ type }) => {
  const [followLinks, setFollowLinks] = useState(false);
  const [scheduled, setScheduled] = useState(false);
  const [frequency, setFrequency] = useState("daily");

  switch (type) {
    case "file-upload":
      return (
        <FormElement>
          <FormLabel label="Upload File" />
          <FormInput type="file" style={{ color: "var(--main-font-color)" }} />
        </FormElement>
      );
    case "url":
      return (
        <>
          <FormElement>
            <FormLabel label="Data URL" />
            <FormInput placeholder="Enter the URL for this data" />
          </FormElement>
          <FormElement>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px" }}>
              <FormToggle
                checked={followLinks}
                onChange={(e) => setFollowLinks(e.target.checked)}
              />
              <FormLabel style={{ marginBottom: 0 }} label="Follow Links" />
            </div>
          </FormElement>
          {
            followLinks && (
              <>
                <FormElement>
                  <FormLabel label="Link Pattern (optional)" />
                  <FormInput placeholder="Enter a regex pattern to match which links to follow (optional)" />
                </FormElement>
                <FormElement>
                  <FormLabel label="Link Depth" />
                  <FormInput type="number" min={1} max={10} placeholder="Enter how many levels of links to follow" />
                </FormElement>
              </>
            )

          }
          <FormElement>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px" }}>
              <FormToggle
                checked={scheduled}
                onChange={(e) => setScheduled(e.target.checked)}
              />
              <FormLabel style={{ marginBottom: 0 }} label="Scheduled" />
            </div>
          </FormElement>
          {
            scheduled && (
              <FormElement>
                <FormLabel label="Frequency" />
                <FormSelector
                  value={frequency}
                  options={[
                    { label: "Hourly", value: "hourly" },
                    { label: "Daily", value: "daily" },
                    { label: "Weekly", value: "weekly" },
                    { label: "Monthly", value: "monthly" },
                  ]} placeholder="Select how often to fetch this data"
                  onChange={(e) => {
                    setFrequency(e.target.value);
                  }}
                />
              </FormElement>
            )
          }
        </>
      );
    case "text":
      return (
        <FormElement>
          <FormLabel label="Data Text" />
          <FormInput as="textarea" rows={5} placeholder="Enter the text for this data" style={{ resize: "vertical" }} />
        </FormElement>
      );
    default:
      return null;
  }
}

export const NewDataDialog = ({ show, onClose }) => {
  const [dataSource, setDataSource] = useState("file-upload");


  return (
    <Dialog
      title="Create Data Item"
      subtitle={""}
      show={show}
      onClose={onClose}
      onOK={onClose}
      okText="Save"
      closeText="Close"
    >
      <FormElement>
        <FormLabel label="Data Name" />
        <FormInput placeholder="Enter a name for this data" />
      </FormElement>
      <FormElement>
        <FormLabel label="Data Source" />
        <FormSelector
          value={dataSource}
          options={[
            { label: "File Upload", value: "file-upload" },
            { label: "URL", value: "url" },
            { label: "Text", value: "text" },
          ]} placeholder="Select a data source type"
          onChange={(e) => {
            setDataSource(e.target.value);
          }}
        />
      </FormElement>
      <MediaTypeFields type={dataSource} />
    </Dialog>
  );
};

export default NewDataDialog;
